import Setup from "../../../../src/pages/integrate/setup/index.md";
import Tutorials from "../../../../src/pages/integrate/tutorials/index.md";
import Guides from "../../../../src/pages/integrate/guides/index.md";
import References from "../../../../src/pages/integrate/references/index.md";
import * as React from 'react';
export default {
  Setup,
  Tutorials,
  Guides,
  References,
  React
};